import { BASE_IMG_URL } from "constants/configConstants";
import { SCHOLARSHIP_PAGE_STATIC_URL } from "constants/index";
import styles from "./HeroV2Mobile.module.scss";
import Header from "@Components/Header";
import Button from "@Components/Button";
import Image from "@Components/Image";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsApp from "hooks/useIsApp";
import useIsMiniProgram from "hooks/useIsMiniProgram";
import HeroStatsBar from "../HeroV2/components/HeroStatsBar/HeroStatsBar";
import { useContext, useEffect } from "react";
import { ScholarshipFormContext } from "@Pages/Scholarship/ScholarshipFormModal";
import useTranslationHook from "hooks/useTranslationHook";

const HeroV2Mobile = ({ isScholarshipPage = true }: { isScholarshipPage?: boolean }) => {
  const isApp = useIsApp();
  const isMiniProgram = useIsMiniProgram();
  const { t } = useTranslationHook();
  const { openForm } = useContext(ScholarshipFormContext);

  useEffect(() => {
    // Add grey background to body for mobile scholarship page
    document.body.style.backgroundColor = "#f9fafb";

    return () => {
      // Reset background when component unmounts
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <>
      <div className={styles.headerContainer}>
        <Header
          hideSearchBar
          {...(isApp && {
            showBackButton: true,
            showHamburger: false,
            isProfileHeader: true,
            profileHeaderTitle: t("scholarship.herov2mobile.profileheadertitle"),
          })}
          {...(isMiniProgram && {
            showHamburger: false,
          })}
          isScholarshipPage={isScholarshipPage}
        />
      </div>

      <div className={styles.heroMobileWrapper}>
        <div
          className={styles.heroImage}
          style={{
            backgroundImage: isScholarshipPage
              ? `url(${SCHOLARSHIP_PAGE_STATIC_URL}/scholar_hero_bg.png)`
              : `url(${BASE_IMG_URL}referralv2-bg.png)`,
          }}
        />

        <div className={styles.heroOverlay}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroHeading}>{t("scholarship.herov2mobile.heading")}</h1>
            <p className={styles.contentWrapper}>{t("scholarship.herov2mobile.description")}</p>
            <Button variant="none" className={styles.applyButton} onClick={openForm}>
              {t("scholarship.herov2mobile.applynow")}
            </Button>
            <p className={styles.heroDeadline}>{t("scholarship.herov2mobile.deadline")}</p>
          </div>
          {isScholarshipPage && (
            <div className={styles.heroImageMobile}>
              <Image
                src={`${SCHOLARSHIP_PAGE_STATIC_URL}/scholar_hero.png`}
                height={204.717}
                width={303.148}
                alt={t("scholarship.herov2mobile.heroalt")}
              />
            </div>
          )}
        </div>
      </div>
      <HeroStatsBar />
    </>
  );
};

export default wrapperHOC(HeroV2Mobile, {
  componentName: "HeroV2Mobile-Scholarship",
  showForChina: true,
});
